import { useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";
import { Text } from "@flare/ui/components";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepFeedback } from "../components/step-feedback";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";
import type { StepProps } from "./step.types";

export default function AttorneyQualities({ answers }: StepProps) {
  const { t } = useTranslation();
  const { leadSource } = answers;
  const choices = [
    {
      label: t("EMPATHY_AND_UNDERSTANDING"),
      value: "Empathy and understanding",
      feedback: t("EMPATHY_AND_UNDERSTANDING_FEEDBACK"),
    },
    {
      label: t("TRACK_RECORD_WITH_CASES_LIKE_MINE"),
      value: "Track record with cases like mine",
      feedback: t("TRACK_RECORD_WITH_CASES_LIKE_MINE_FEEDBACK"),
    },
    {
      label: t("LOCAL_KNOWLEDGE_AND_COURT_EXPERIENCE"),
      value: "Local knowledge and court experience",
      feedback: t("LOCAL_KNOWLEDGE_AND_COURT_EXPERIENCE_FEEDBACK"),
    },
    {
      label: t("IM_STILL_DECIDING"),
      value: "I’m still deciding",
      feedback: t("IM_STILL_DECIDING_FEEDBACK"),
    },
  ];

  const { watch } = useFormContext();
  const attorneyQuality = watch(funnelInputsNameMap.attorneyQualities);
  const feedback = attorneyQuality
    ? choices.find(({ value }) => value === attorneyQuality)?.feedback
    : "";

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          {leadSource === "legal-plan" && (
            <Text variant="body1-highlight" className="mt-sp-4 text-center">
              {t("LEGAL_PLAN_LSS_FUNNEL_PRE_TITLE")}
            </Text>
          )}
          <StepTitle>{t("FUNNEL_ATTORNEY_QUALITIES_TITLE")}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.attorneyQualities}
            choices={choices}
            required
          />
          <StepFeedback>{feedback}</StepFeedback>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
